<template>
    <div class="model-permission">
        <br>
        <el-card
            :body-style="{padding: '20px', display: 'flex', alignItems: 'center'}"
            shadow="hover"
        >
            <div class="label-model">
                <strong>{{ alterablePermission.model_name }}</strong>
            </div>
            <div class="form-flex">
                <el-select
                    v-model="alterablePermission.create_roles_uid"
                    placeholder=""
                    multiple
                >
                    <el-option
                        v-for="role in concreteRoles"
                        :key="role.uid"
                        :label="role.name"
                        :value="role.uid">
                    </el-option>
                </el-select>
                <el-select
                    v-model="alterablePermission.delete_roles_uid"
                    placeholder=""
                    multiple
                >
                    <el-option
                        v-for="role in concreteRoles"
                        :key="role.uid"
                        :label="role.name"
                        :value="role.uid">
                    </el-option>
                </el-select>
                <el-select
                    v-model="alterablePermission.update_roles_uid"
                    placeholder=""
                    multiple
                >
                    <el-option
                        v-for="role in concreteRoles"
                        :key="role.uid"
                        :label="role.name"
                        :value="role.uid">
                    </el-option>
                </el-select>
                <el-select
                    v-model="alterablePermission.retrieve_roles_uid"
                    placeholder=""
                    multiple
                >
                    <el-option
                        v-for="role in concreteRoles"
                        :key="role.uid"
                        :label="role.name"
                        :value="role.uid">
                    </el-option>
                </el-select>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {
    },

    props: {
        permission: {
            type: Object,
            required: true,
        }
    },

    data (){
        return {
            alterablePermission: JSON.parse(JSON.stringify(this.permission)),
        };
    },

    computed: {
        ...mapGetters([
            'concreteRoles'
        ]),
    },

    mounted (){
    },

    methods: {
        save (){
            let strPerm = JSON.stringify(this.permission);
            let strAlterablePerm = JSON.stringify(this.alterablePermission);
            if(strPerm === strAlterablePerm) return Promise.resolve('not save');
            return this.$store.dispatch('patchItem', {
                item: {
                    url: this.permission.url,
                    create_roles_uid: this.alterablePermission.create_roles_uid,
                    update_roles_uid: this.alterablePermission.update_roles_uid,
                    delete_roles_uid: this.alterablePermission.delete_roles_uid,
                    retrieve_roles_uid: this.alterablePermission.retrieve_roles_uid,
                },
                model: 'concretePermissions'
            });
        }
    },
};
</script>

<style lang="scss">
.model-permission{
    .form-flex{
        display: flex;
        justify-content: space-between;
        flex-basis: 85%;
        align-items: center;
    }
    .label-model{
        flex-basis: 15%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        // cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/permissionsManagement/model-permission.vue